import { startCase, camelCase } from 'lodash'
export const toTitleCase = (text: string) => startCase(camelCase(text))
